// ConversationMain.jsx
import React from 'react';
import AnimatedAvatar from '../../components/chatbot.conversation/AnimatedAvatar';
import ChatBox from '../../components/chatbot.conversation/Chatbox';

function ChatBotPage() {
    return (
        <div className="App">
            <AnimatedAvatar />
            <ChatBox />
        </div>
    );
}

export default ChatBotPage;